import { useQuery } from '@apollo/client';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { IntegrationFeatureStatus } from '../../graphql/generated/graphql';
import { INSTALLABLE_PLATFORM_INFO_MAP } from '../../integrations/IntegrationPlatformInfo';

// eslint-disable-next-line slab-graphql/no-unused-fields
const SEARCH_SOURCES_QUERY = gql(/** @complexity 4 */ `
  query externalSearchSources($platform: String!) {
    sources: externalSearchSources(platform: $platform) {
      id
      name
    }
  }
`);

const INTEGRATION_FRAGMENT = gql(`
  fragment useTeamSearchSources_integration on Integration {
    id
    platform
    features {
      teamSearch
    }
  }
`);

const useTeamSearchSources = ({
  features,
  platform,
}: DocumentType<typeof INTEGRATION_FRAGMENT>) => {
  const teamSearchPlatform =
    INSTALLABLE_PLATFORM_INFO_MAP[platform]?.teamSearchPlatform;

  return useQuery(SEARCH_SOURCES_QUERY, {
    fetchPolicy: 'network-only',
    skip: features?.teamSearch !== IntegrationFeatureStatus.Enabled,
    variables: { platform: teamSearchPlatform || platform },
  });
};

export default useTeamSearchSources;
